var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"settings columns",attrs:{"id":"settings-view"}},[_c('div',{staticClass:"column is-one-fifth"},[_c('SideMenu')],1),_c('div',{staticClass:"column is-two-fifths"},[_c('div',{staticClass:"box settings-content"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }